﻿import { Button, Flex } from '@chakra-ui/react'
import { addMonths } from 'date-fns'
import { DateFormControl, InputFormControl, RadioGroupFormControl } from 'BrokerTsLib/src/components'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { HorizontalRadios } from '@/components/HorizontalRadios'
import { FormBody } from '@/containers/forms/FormBody'
import { FormRow } from '@/containers/forms/FormRow'
import { FormSection } from '@/containers/forms/FormSection'
import type { FormValues } from './types'

type Props = {
  isFromPs: boolean
  minStartDate: Date
  isPending: boolean
  isDisabled: boolean
  showSubmitButton: boolean
}

export const StockSection = ({ showSubmitButton = true, isFromPs, minStartDate, isPending, isDisabled }: Props) => {
  const { control, watch, setValue } = useFormContext<FormValues>()

  const stockStartDate = watch('stockStartDate')

  useEffect(() => {
    setValue('stockEndDate', stockStartDate ? addMonths(stockStartDate, 36) : null)
  }, [stockStartDate])

  return (
    <FormSection number={2} sectionTitle="Skladové pojištění">
      <FormBody>
        <FormRow>
          <InputFormControl
            label="Číslo LS"
            name="leasingContractNumber"
            control={control}
            isRequired={isFromPs}
            isDisabled={isFromPs}
          />

          <RadioGroupFormControl
            name='stockType'
            valueAsNumber
            isRequired
            label='Typ'
            isDisabled={isFromPs || isDisabled}
          >
            <HorizontalRadios options={[
              { value: "1127", label: "BEFORE" },
              { value: "1128", label: "AFTER" }
            ]} />
          </RadioGroupFormControl>
        </FormRow>

        <FormRow>
          <DateFormControl
            name="stockStartDate"
            label="Počátek pojištění"
            control={control}
            isRequired
            minDate={minStartDate}
          />

          <DateFormControl
            name="stockEndDate"
            label="Konec pojištění"
            control={control}
            isDisabled
          />
        </FormRow>

        {showSubmitButton &&
          <Flex justify="center" pt={4}>
            <Button type="submit" colorScheme="blue" isLoading={isPending} isDisabled={isDisabled}>
              Vytvořit skladové pojištění
            </Button>
          </Flex>
        }
      </FormBody>
    </FormSection>
  )
}
